module.exports = __webpack_public_path__ + "static/hogd-85716c27675396750bf4805344eaf34a.png";